function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1924(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.09,
    height: 20.82,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 10.41,
    fontFamily: "Arial"
  }, "\n        Hendry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.82,
    width: 37.09,
    height: 21.78,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1114285714285717
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 31.71,
    fontFamily: "Arial"
  }, "\n        Collier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.6,
    width: 37.09,
    height: 27.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8728571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 56.155,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.71,
    width: 37.09,
    height: 32.92,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2920000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 86.16999999999999,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 102.63,
    width: 37.09,
    height: 33.04,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.608
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 119.14999999999999,
    fontFamily: "Arial"
  }, "\n        Dixie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.67,
    width: 37.09,
    height: 42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1816666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 156.67,
    fontFamily: "Arial"
  }, "\n        Glades\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 177.66,
    width: 37.09,
    height: 42.12,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.418000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 198.72,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.78,
    width: 37.09,
    height: 45.02,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.298571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 242.29,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 264.8,
    width: 37.09,
    height: 45.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.418000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 287.735,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 310.67,
    width: 37.09,
    height: 47.08,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.298571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 334.21000000000004,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 357.75,
    width: 37.09,
    height: 48.53,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.63625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 382.015,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 406.28,
    width: 37.09,
    height: 49.14,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.121111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 430.84999999999997,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 455.41,
    width: 37.09,
    height: 55.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.63625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 483.365,
    fontFamily: "Arial"
  }, "\n        Sarasota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 511.32,
    width: 37.09,
    height: 61.12,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1816666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 541.88,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 572.44,
    width: 37.09,
    height: 62.81,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.298571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 603.845,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 635.25,
    width: 37.09,
    height: 64.75,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.121111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 18.545,
    y: 667.625,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 0,
    width: 43.23,
    height: 56.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.40375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.705,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.32,
    y: 0,
    width: 47.04,
    height: 56.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.83999999999999,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.36,
    y: 0,
    width: 47.04,
    height: 56.59,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.88,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.4,
    y: 0,
    width: 48.23,
    height: 56.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.038333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.51500000000001,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.63,
    y: 0,
    width: 52.35,
    height: 56.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.54375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.805,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.98,
    y: 0,
    width: 53.78,
    height: 56.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.963333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.87,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.76,
    y: 0,
    width: 54.02,
    height: 56.59,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.002222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.77,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.78,
    y: 0,
    width: 60.68,
    height: 56.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.431666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.11999999999995,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 443.47,
    y: 0,
    width: 62.98,
    height: 56.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.287777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474.96000000000004,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Highlands\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.45,
    y: 0,
    width: 63.62,
    height: 56.59,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.084285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.26,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.07,
    y: 0,
    width: 64.73,
    height: 56.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.4350000000001,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.8,
    y: 0,
    width: 65.2,
    height: 56.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.07375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.4,
    y: 28.295,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 56.59,
    width: 63.19,
    height: 59.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.911
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 86.14500000000001,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 115.7,
    width: 63.19,
    height: 65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.531666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 148.2,
    fontFamily: "Arial"
  }, "\n        Desoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 180.7,
    width: 63.19,
    height: 67.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.89875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 214.48,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 248.26,
    width: 63.19,
    height: 67.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.89875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 282.11,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 315.96,
    width: 63.19,
    height: 69.69,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.319
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 350.80499999999995,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 385.65,
    width: 63.19,
    height: 69.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.027142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 420.53,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 455.41,
    width: 63.19,
    height: 78.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 494.83500000000004,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 534.26,
    width: 63.19,
    height: 82.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.531666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 575.64,
    fontFamily: "Arial"
  }, "\n        Hardee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.09,
    y: 617.03,
    width: 63.19,
    height: 82.97,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.89875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.685,
    y: 658.515,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 56.59,
    width: 65.12,
    height: 80.79,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.853333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.84,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.4,
    y: 56.59,
    width: 65.39,
    height: 80.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.095,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.79,
    y: 56.59,
    width: 68.45,
    height: 80.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.408333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.015,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.24,
    y: 56.59,
    width: 69.34,
    height: 80.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.91,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.58,
    y: 56.59,
    width: 78.78,
    height: 80.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.96999999999997,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.37,
    y: 56.59,
    width: 80.9,
    height: 80.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.82,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.26,
    y: 56.59,
    width: 83.62,
    height: 80.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.541428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.0699999999999,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.88,
    y: 56.59,
    width: 88.12,
    height: 80.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.09875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.94,
    y: 96.98500000000001,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 137.38,
    width: 87.09,
    height: 83.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.825,
    y: 179.185,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 220.99,
    width: 87.09,
    height: 84.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.038333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.825,
    y: 263.105,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 305.21,
    width: 87.09,
    height: 90.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.441428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.825,
    y: 350.59499999999997,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 395.99,
    width: 87.09,
    height: 97.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.676666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.825,
    y: 444.545,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 493.1,
    width: 87.09,
    height: 99.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.441428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.825,
    y: 542.9200000000001,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 592.73,
    width: 87.09,
    height: 107.27,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.825,
    y: 646.365,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.37,
    y: 137.38,
    width: 99.24,
    height: 99.19,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.99,
    y: 186.975,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.61,
    y: 137.38,
    width: 117.66,
    height: 99.19,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.44,
    y: 186.975,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.27,
    y: 137.38,
    width: 126.44,
    height: 99.19,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.49,
    y: 186.975,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.71,
    y: 137.38,
    width: 169.29,
    height: 99.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.919
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.355,
    y: 186.975,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.37,
    y: 236.58,
    width: 120.55,
    height: 148.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.22142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.645,
    y: 310.96000000000004,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.37,
    y: 385.34,
    width: 120.55,
    height: 152.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.091666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.645,
    y: 461.825,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.37,
    y: 538.31,
    width: 120.55,
    height: 161.69,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.645,
    y: 619.155,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.91,
    y: 236.58,
    width: 183.13,
    height: 129.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 399.475,
    y: 301.49,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.04,
    y: 236.58,
    width: 208.96,
    height: 129.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.2275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.52,
    y: 301.49,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.91,
    y: 366.39,
    width: 239.01,
    height: 134.85,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.237499999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.415,
    y: 433.815,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.91,
    y: 501.24,
    width: 239.01,
    height: 198.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 49.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.415,
    y: 600.62,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.93,
    y: 366.39,
    width: 153.07,
    height: 333.61,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.613999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.4649999999999,
    y: 533.1949999999999,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1924);
export default __webpack_public_path__ + "static/media/1924.fccbdb7e526db841402dc546ef08be02.svg";
export { ForwardRef as ReactComponent };